import { getStoredUser } from '../../api/client';
// Dev-only controls:
// - REACT_APP_DEBUG_UI=true
export function isDebugBuildEnabled() {
  return process.env.REACT_APP_DEBUG_UI === 'true';
}

export function isAdminUser() {
  const user = getStoredUser();
  const role = user?.role;
  return role === 'ADMIN';
}

export function shouldShowDebugUI() {
  return isDebugBuildEnabled() && isAdminUser();
}
